// Register
import Login from '@/views/Register/Login.vue'
import {RouteConfig} from "vue-router";

const registerRoutes: Array<RouteConfig> = [
  {
    path: "/login",
    name: "Login",
    meta: { title: "Login Page - App", guest: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Register/Login.vue"),
  },
  {
    path: "/admin/forgot-pass",
    name: "ForgotPass",
    component: () => import("../views/Register/ForgetPassword.vue"),
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/admin/forgot-pass-v2",
    name: "ForgotPassV2",
    component: () => import("../views/Register/ForgetPasswordV2.vue"),
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/admin/forgot-pass-v3",
    name: "ForgotPassV3",
    component: () => import("../views/Register/ForgetPasswordV3.vue"),
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/admin/reset-pass",
    name: "ResetPass",
    component: () => import("../views/Register/ResetPassword.vue"),
    meta: {
      requireAuth: false,
    },
  },

  {
    path: "/admin/reset-pass-v2",
    name: "ResetPassV2",
    component: () => import("../views/Register/ResetPasswordV2.vue"),
    meta: {
      requireAuth: false,
    },
  },

  {
    path: "/admin/two_factor",
    name: "TwoFactor",
    component: () => import("../views/Register/TwoFactor.vue"),
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/admin/reset_success",
    name: "ResetPasswordSuccess",
    component: () => import("../views/Register/ResetPasswordSuccess.vue"),
    meta: {
      requireAuth: false,
    },
  },
];

export default registerRoutes;
